// issueReport.js

import { baseURL } from 'utils/api'
import Dictionary from '../dictionary'
import axios from 'axios'

const { notification } = Dictionary

const notificationServies = {
  view: async (paramsObj) => {
    return axios.get(baseURL + notification.list(), { params: paramsObj })
  },
  add: async (data) => {
    return axios.post(baseURL + notification.create(), data)
  },
  test: async (data) => {
    return axios.post(baseURL + notification.test(), data)
  },
  delete: async (id) => {
    return axios.delete(baseURL + notification.delete(id))
  },
  send: async (id, data) => {
    return axios.post(baseURL + notification.send(id), data)
  },
  edit: async (id, data) => {
    return axios.put(baseURL + notification.getById(id), data)
  },
  comment: async (id, data) => {
    return axios.put(baseURL + notification.comment(id), data)
  },
  getDetailById: async (id) => {
    return axios.get(baseURL + notification.getById(id))
  },
  country: async () => {
    return axios.get(baseURL + notification.country())
  },
  state: async (countryID) => {
    return axios.post(baseURL + notification.state(),countryID)
  },
  city: async (data) => {
    return axios.post(baseURL + notification.city(),data)
  },
  subAddLines: async (data) => {
    return axios.post(baseURL + notification.subAddLines(), data)
  },
  zipcode: async (data) => {
    return axios.post(baseURL + notification.zipcode(), data)
  },
}
export default notificationServies